"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerType = exports.InvoiceDeliveryType = exports.Currency = void 0;
var Currency;
(function (Currency) {
    Currency["SEK"] = "SEK";
    Currency["NOK"] = "NOK";
    Currency["DKK"] = "DKK";
    Currency["EUR"] = "EUR";
    Currency["USD"] = "USD";
    Currency["GBP"] = "GBP";
    Currency["JPY"] = "JPY";
})(Currency || (exports.Currency = Currency = {}));
/**
 * Invoice delivery types for customer references.
 * - PRINT: Invoice will be printed and sent by post.
 * - EMAIL: Invoice will be sent via email.
 * - ELECTRONICINVOICE: Invoice will be sent electronically, typically through a B2B invoicing system.
 * @enum {string}
 * @property {string} PRINT - Invoice will be printed and sent by post.
 * @property {string} EMAIL - Invoice will be sent via email.
 * @property {string} ELECTRONICINVOICE - Invoice will be sent electronically, typically through a B2B invoicing system.
 *
 */
var InvoiceDeliveryType;
(function (InvoiceDeliveryType) {
    InvoiceDeliveryType["PRINT"] = "PRINT";
    InvoiceDeliveryType["EMAIL"] = "EMAIL";
    InvoiceDeliveryType["ELECTRONICINVOICE"] = "ELECTRONICINVOICE";
})(InvoiceDeliveryType || (exports.InvoiceDeliveryType = InvoiceDeliveryType = {}));
/**
 * kundtyp
 */
var CustomerType;
(function (CustomerType) {
    CustomerType["horeca"] = "horeca";
    CustomerType["dvh"] = "dvh";
    CustomerType["wholesale"] = "wholesale";
    CustomerType["office"] = "office";
    CustomerType["systembolaget"] = "systembolaget";
    CustomerType["supplier"] = "supplier";
    CustomerType["export"] = "export";
    CustomerType["other"] = "other";
})(CustomerType || (exports.CustomerType = CustomerType = {}));
